import { JsonProperty } from "../utilities/json-property";
import { OrderStatus } from '../ordering/enums/order-status';
import { OrderInvoiceStatus } from '../ordering/enums/order-invoice-status';
import { OrderProductionStatus } from '../ordering/enums/order-production-status';
import { OrderShipmentStatus } from '../ordering/enums/order-shipment-status';
import { CurrencyType } from "../utilities/type-models";
import { PendingReason } from '../ordering/enums/pending-reason';


export class SearchOrderSummary {

    public id : string = '';
    public dealerId : string = '';
    public dealerName : string = '';
    public groupId : number = 0;
    public serviceCenterId : string = '';
    
    // public Division Division { get; set; }
    public status : OrderStatus = OrderStatus.Cancelled;
    public productionStatus : OrderProductionStatus = OrderProductionStatus.NotApplicable;
    public shipmentStatus : OrderShipmentStatus = OrderShipmentStatus.NotApplicable;
    public invoiceStatus : OrderInvoiceStatus = OrderInvoiceStatus.NotApplicable;
    public pendingReason : PendingReason = PendingReason.None;
    // public OrderSource Source { get; set; }
    // public DateTime? CutoffDate { get; set; }
    // public ShipmentMethod ShipmentMethod { get; set; }

    public jobName : string = '';
    public poNumber : string = '';
    public quantity : number = 0;
    public description : string = '';

    public hardware : number = 0;
    public track : number = 0;
    public longSections : number = 0;
    public sections : number = 0;
    public doors : number = 0;
    public singles : number = 0;
    public units : number = 0;
    public weight : number = 0;

    public amount: number = 0.0;
    public freight: number = 0.0;
    public currencyId: CurrencyType = '';
    public trackingNumber: string = '';

    @JsonProperty({ toType: 'datetime' })
    public lastModified : Date;
    public rowVersion : string = '';

}